import {shiftAnalyticsDate} from './analyticsDates';

type Row=Record<string,any>;
const count=(value:unknown):number|null=>{
  if(value==null||value===''||typeof value==='boolean')return null;
  const n=Number(value);return Number.isSafeInteger(n)&&n>=0?n:null;
};
/** The owning daily row binds a period report to its ad. Unique audiences never add across ads or dates. */
export function exactPeriodAudience(rows:Row[],startDate:string,endDate:string):{reach:number|null;frequency:number|null}{
  const unavailable={reach:null,frequency:null};
  shiftAnalyticsDate(startDate,0);shiftAnalyticsDate(endDate,0);
  const days=(Date.parse(endDate)-Date.parse(startDate))/86400000+1;
  if(days<1||days>732||!rows.length||rows.length!==days)return unavailable;
  const dates=new Set(Array.from({length:days},(_,index)=>shiftAnalyticsDate(startDate,index)));
  const first=rows[0];
  if(!Number.isSafeInteger(first.adAccountId)||first.adAccountId<=0||typeof first.entityId!=='string'||!first.entityId)return unavailable;
  if(rows.some(row=>row.level!=='ad'||row.adAccountId!==first.adAccountId||row.entityId!==first.entityId||row.reported===false||!dates.has(row.date)))return unavailable;
  if(new Set(rows.map(row=>row.date)).size!==days)return unavailable;
  let impressions=0;
  for(const row of rows){const n=count(row.impressions);if(n==null)return unavailable;impressions+=n;}
  const matches=rows.flatMap(row=>Array.isArray(row.extraMetrics?.periodReports)?row.extraMetrics.periodReports:[]).filter(report=>report&&report.dateStart===startDate&&report.dateStop===endDate);
  if(!matches.length)return unavailable;
  let reach:number|undefined;
  for(const report of matches){
    const measuredReach=count(report.reach),measuredImpressions=count(report.impressions);
    // Explicit report identities must agree with the daily row that carries them.
    if(report.adAccountId!=null&&report.adAccountId!==first.adAccountId||report.entityId!=null&&report.entityId!==first.entityId||report.level!=null&&report.level!=='ad')return unavailable;
    if(measuredReach==null||measuredImpressions!==impressions||measuredReach>impressions||impressions>0&&measuredReach===0||reach!==undefined&&reach!==measuredReach)return unavailable;
    reach=measuredReach;
  }
  return {reach:reach!,frequency:reach!>0?impressions/reach!:null};
}
